// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__DxO7N","inner":"Footer_inner__5W-Qn","nextIcon":"Footer_nextIcon__3Z3PO","innerLeft":"Footer_innerLeft__2HHqn"};